import React, { useState } from 'react';
import { signInWithEmailAndPassword, signInWithPopup, GoogleAuthProvider } from "firebase/auth";
import { auth } from "../../services/firebase";
import Swal from 'sweetalert2';
import './SignIn.css';
import Navbar from '../Navbar/Navbar';
import SideImage from '../SideImg/SideImg';
import AuthBanner from '../../assets/signupuserbanner.png';
import { useNavigate } from 'react-router-dom';

const SignIn = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.email) newErrors.email = 'Email is required';
    if (!formData.password) newErrors.password = 'Password is required';
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleEmailSignIn = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setIsLoading(true);
    try {
      await signInWithEmailAndPassword(auth, formData.email, formData.password);
      // Success logic, after a successful sign-in
      Swal.fire({
        title: 'Success!',
        text: 'You have successfully signed in.',
        icon: 'success'
      }).then(() => {
        navigate('/'); // Redirect to home after successful login
      });

    } catch (error) {
      console.error("Sign in error:", error);
      let errorMessage = "Sign in failed. Please try again.";

      // The switch statement now runs first to determine the correct message
        switch(error.code) {
        case 'auth/invalid-email':
          errorMessage = "Please enter a valid email address.";
          break;
        case 'auth/user-not-found':
          errorMessage = "No account found with this email.";
          break;
        case 'auth/wrong-password':
          errorMessage = "Incorrect password. Please try again.";
          break;
        case 'auth/too-many-requests':
          errorMessage = "Too many attempts. Please try again later.";
          break;
        default:
          // Fallback for other potential errors
          errorMessage = error.message || errorMessage;
          break;     
        }
        Swal.fire("Error", errorMessage, "error");
      } finally {
        setIsLoading(false);
      }
    };

  const handleGoogleSignIn = async () => {
    try {
      const provider = new GoogleAuthProvider();
      await signInWithPopup(auth, provider);
      Swal.fire({
        title: 'Success!',
        text: 'You have successfully signed in with Google.',
        icon: 'success'
      }).then(() => {
        navigate('/'); // Redirect to home after successful login
      });
    } catch (error) {
      console.error("Google sign in error:", error);
      Swal.fire("Error", error.message || "Google sign in failed.", "error");
    }
  };

  return (
    <div className='page__wrapper'>
      <Navbar />
      <div className='auth__container'>
        <SideImage sideBannerSrc={AuthBanner} sideBannerAlt={"Alex Menswear Auth Banner"} />
        <div className="sign-in-container">
          <div className="sign-in-box">
            <div className="signin-header">
              <h1>Sign In</h1>
              <button 
                type="button" 
                className="google-btn"
                onClick={handleGoogleSignIn}
                disabled={isLoading}
              >
                {isLoading ? 'Signing In...' : 'Sign In With Google'}
              </button>
              <p>Create your account to have access to a personalized experience.</p>
            </div>

            <form className="sign-in-form" onSubmit={handleEmailSignIn}>
              <input
                type="email"
                name="email"
                placeholder="Email Address" 
                className={`sign-in-input ${errors.email ? 'input-error' : ''}`}
                autoComplete="username"
                value={formData.email}
                onChange={handleChange}
              />
              {errors.email && <span className="error-message">{errors.email}</span>}
              
              <input
                type="password"
                name="password"
                placeholder="Password"
                className={`sign-in-input ${errors.password ? 'input-error' : ''}`}
                autoComplete="current-password"
                value={formData.password}
                onChange={handleChange}
              />
              {errors.password && <span className="error-message">{errors.password}</span>}
              
              <button 
                type="submit" 
                className="sign-in-button"
                disabled={isLoading}
              >
                {isLoading ? 'Signing In...' : 'Log In'}
              </button>
            </form>

            <div className="sign-in-links">
              <p>Don't have an Account? <a href="/sign-up">Create One</a></p>
              <a href="/forgot-password">Forgot your password?</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SignIn;